export default function PHP_str_replace() {
  return (
    <div>
      <h1>PHP_str_replace</h1>
    </div>
  );
}
